import { DataState, DrawerTabs, SideDrawerShell } from "../../../common/components";

const GOAL_TABS = [
  { key: "weekly", label: "Weekly", icon: "weekly" },
  { key: "monthly", label: "Monthly", icon: "monthly" },
  { key: "quarterly", label: "Quarterly", icon: "quarterly" },
  { key: "yearly", label: "Yearly", icon: "yearly" },
];

export default function TeamMemberReviewDrawer({
  open,
  member,
  detail,
  cadence,
  onCadenceChange,
  onClose,
}) {
  const goals = detail?.cadenceGoals?.[cadence] || [];

  return (
    <SideDrawerShell
      open={open}
      onClose={onClose}
      subtitle="My Team"
      title={member ? `${member.name} — Review` : "Review"}
      footer={(
        <>
          <span className="v2drw-foot-spacer" />
          <button className="v2drw-btn-cancel" type="button" onClick={onClose}>Close</button>
          <button className="v2drw-btn-save" type="button">Submit review</button>
        </>
      )}
    >
      <DataState loading={!detail} empty={!detail} emptyText="No detail data found.">
        <div className="rtv2-mate-kpis">
          <div><span>Current</span><b>{detail?.currentStage}</b></div>
          <div><span>Target</span><b>{detail?.targetStage}</b></div>
          <div><span>Progress</span><b>{detail?.stageProgress}%</b></div>
          <div><span>Last review</span><b>{detail?.lastReview}</b></div>
        </div>

        <section className="rtv2-mate-sec">
          <h4>Score history by parameter</h4>
          <table className="rtv2-score-table">
            <thead>
              <tr>
                <th>Parameter</th>
                <th>Current</th>
                <th>Previous</th>
                <th>Delta</th>
                <th>Trend</th>
              </tr>
            </thead>
            <tbody>
              {(detail?.parameterScores || []).map((p) => {
                const d = (p.curr || 0) - (p.prev || 0);
                return (
                  <tr key={p.name}>
                    <td>{p.name}</td>
                    <td>{p.curr?.toFixed(1)}</td>
                    <td>{p.prev?.toFixed(1)}</td>
                    <td className={d >= 0 ? "up" : "down"}>{d >= 0 ? "+" : ""}{d.toFixed(1)}</td>
                    <td>
                      <div className="rtv2-spark">
                        {(p.hist || []).map((h, i) => <i key={i} style={{ height: `${Math.max(10, (h / 5) * 28)}px` }} />)}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </section>

        <section className="rtv2-mate-sec">
          <h4>Goals by cadence</h4>
          <DrawerTabs tabs={GOAL_TABS} activeTab={cadence} onChange={onCadenceChange} />
          <div className="rtv2-goal-approve-list">
            {goals.map((g, idx) => (
              <div key={`${g.title}-${idx}`} className={`rtv2-goal-approve${g.approved ? " approved" : ""}`}>
                <div className="bd">
                  <b>{g.title}</b>
                  <small>{g.kpi}</small>
                </div>
                <div className="pg">{g.progress}%</div>
                <div className="acts">
                  <button type="button" className={g.approved ? "on" : ""}>{g.approved ? "Approved" : "Approve"}</button>
                  <button type="button">Feedback</button>
                </div>
              </div>
            ))}
            {goals.length === 0 ? <div className="rtv2-state">No goals for this cadence.</div> : null}
          </div>
        </section>
      </DataState>
    </SideDrawerShell>
  );
}
